import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { sb, User, Company } from '../services/supabase';

export default function CompanyAdminSidebar({ user, company }: { user: User; company: Company }) {
  const navigate = useNavigate();
  const isManager = user.role === 'manager';
  const hasLeave = company.feature_leave !== false;
  const hasPayroll = company.feature_payroll === true;

  const navItems = [
    { section: 'Overview', items: [
      { to: '/company/dashboard', icon: '📊', label: 'Dashboard' },
      { to: '/company/attendance', icon: '✅', label: "Today's Attendance" },
    ]},
    { section: 'People', items: [
      { to: '/company/employees', icon: '👥', label: isManager ? 'My Team' : 'Employees' },
      ...(hasLeave ? [{ to: '/company/leaves', icon: '🌴', label: 'Leave Requests' }] : []),
    ]},
    ...(!isManager ? [{
      section: 'Setup', items: [
        { to: '/company/shifts', icon: '🕐', label: 'Shifts' },
        { to: '/company/locations', icon: '📍', label: 'Locations' },
        ...(hasLeave ? [{ to: '/company/leave-setup', icon: '📋', label: 'Leave Policy' }] : []),
        ...(hasPayroll ? [{ to: '/company/payroll', icon: '💰', label: 'Payroll' }] : []),
        { to: '/company/kiosk', icon: '📟', label: 'Kiosk Devices' },
      ]
    }] : []),
    { section: 'Reports', items: [
      { to: '/company/reports', icon: '📈', label: 'Reports & Export' },
    ]},
  ];

  return (
    <aside style={{ background: 'var(--surface)', borderRight: '1px solid var(--border)', display: 'flex', flexDirection: 'column', padding: '24px 0', overflowY: 'auto', width: 240, flexShrink: 0 }}>
      <div style={{ padding: '0 20px 20px', borderBottom: '1px solid var(--border)', marginBottom: 20 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, #00C9A7, #845EC2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>⏱</div>
          <div style={{ fontSize: 18, fontWeight: 800 }}>ClockedIQ</div>
        </div>
        <div style={{ background: 'var(--surface2)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 12px' }}>
          <div style={{ fontSize: 10, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 1, fontWeight: 700, marginBottom: 2 }}>{isManager ? 'Manager' : 'Company'}</div>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--accent)' }}>{company.name}</div>
        </div>
      </div>
      {navItems.map(section => (
        <div key={section.section} style={{ padding: '0 12px', marginBottom: 16 }}>
          <div style={{ fontSize: 10, fontWeight: 700, color: 'var(--muted)', letterSpacing: 1, textTransform: 'uppercase', padding: '0 8px', marginBottom: 6 }}>{section.section}</div>
          {section.items.map(item => (
            <NavLink key={item.to} to={item.to} style={({ isActive }) => ({ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 10, fontSize: 14, fontWeight: 600, textDecoration: 'none', color: isActive ? 'var(--accent)' : 'var(--muted)', background: isActive ? '#00C9A715' : 'transparent', transition: 'all 0.15s' })}>
              <span style={{ fontSize: 16, width: 20, textAlign: 'center' }}>{item.icon}</span>{item.label}
            </NavLink>
          ))}
        </div>
      ))}
      <div style={{ marginTop: 'auto', padding: '16px 12px 0', borderTop: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px' }}>
          <div style={{ width: 34, height: 34, borderRadius: 10, background: 'linear-gradient(135deg, #00C9A7, #845EC2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 800, flexShrink: 0 }}>{user.full_name?.charAt(0) || 'A'}</div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700 }}>{user.full_name}</div>
            <div style={{ fontSize: 11, color: 'var(--accent)', fontFamily: 'var(--mono)' }}>{isManager ? 'manager' : 'company_admin'}</div>
          </div>
        </div>
        <button onClick={async () => { await sb.auth.signOut(); navigate('/login'); }} style={{ width: '100%', marginTop: 8, background: 'transparent', border: '1px solid var(--border)', color: 'var(--muted)', borderRadius: 8, padding: 8, fontSize: 12, cursor: 'pointer', fontFamily: 'var(--font)' }}>← Sign Out</button>
      </div>
    </aside>
  );
}
